import BasePage from '../../components/layout/BasePage'
import ContactField from './components/ContactField'

export default function Contact() {
  return (
    <BasePage>
      <ContactField />
    </BasePage>
  )
}
